import React, { useEffect, useState } from 'react';
import Page from '@Containers/Page';
import { HashRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import HeaderContainer from '@Pages/History/HeaderContainer';
import { paths } from '@AppRoutes/constants';
import NewRelicService from '@Services/NewRelicService';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import AutoSave from './AutoSave';

import './AutoSave.scss';
import './HistoryModal.scss';

export default function HistoryContainer() {
  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState(location);

  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    setCurrentLocation(location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentLocation !== location) {
      NewRelicService.trackRouteChanges(location.pathname);
    }
    RouteChangeTracking.handleSkipLinkFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    // FR-1.1/FR-3.2: render the main header inside the `.react-page` scroll root so it (and the
    // History title) scroll away; `Main.jsx` suppresses its sibling header for the History routes
    // so exactly one `#header` renders. Only the Recent/Saved tab bar stays sticky (History.scss).
    <Page withFooter renderHeaderInsideScrollRoot headerType="main">
      <div id="history" className="history-main-wrapper">
        <main id="main-content" aria-labelledby="history-title">
          <HeaderContainer />
          <section className="history-page rx-list-wrapper">
            <Router>
              <Switch>
                <Route path={paths.HISTORY_RECENT} render={() => <AutoSave page="recent" key="recent" />} />
                <Route path={paths.HISTORY_SAVED} render={() => <AutoSave page="saved" key="saved" />} />
              </Switch>
            </Router>
          </section>
        </main>
      </div>
    </Page>
  );
}
